<template>
  <svg :width="width" :height="height" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14 12V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.59333 14 2 13.4 2 12.6667V3.33333C2 2.97971 2.14048 2.64057 2.39052 2.39052C2.64057 2.14048 2.97971 2 3.33333 2H12.6667C13.0203 2 13.3594 2.14048 13.6095 2.39052C13.8595 2.64057 14 2.97971 14 3.33333V4H8C7.26 4 6.66667 4.6 6.66667 5.33333V10.6667C6.66667 11.0203 6.80714 11.3594 7.05719 11.6095C7.30724 11.8595 7.64638 12 8 12H14ZM8 10.6667H14.6667V5.33333H8V10.6667ZM10.6667 9C10.4015 9 10.1471 8.89464 9.95956 8.70711C9.77202 8.51957 9.66667 8.26522 9.66667 8C9.66667 7.73478 9.77202 7.48043 9.95956 7.29289C10.1471 7.10536 10.4015 7 10.6667 7C10.9319 7 11.1862 7.10536 11.3738 7.29289C11.5613 7.48043 11.6667 7.73478 11.6667 8C11.6667 8.26522 11.5613 8.51957 11.3738 8.70711C11.1862 8.89464 10.9319 9 10.6667 9Z" :fill="iconColor"/>
  </svg>
</template>

<script>
export default {
  props: {
    iconName: {
      type: String,
      default: "iconWallet",
    },
    width: {
      type: [Number, String],
      default: 18,
    },
    height: {
      type: [Number, String],
      default: 18,
    },
    iconColor: {
      type: String,
      default: "currentColor",
    },
  },
};
</script>
